'use strict';

var _ = require('lodash');

function ChangePasswordController (UserStore, RoutingUtil, SaturnGrowl) {
  var vm = this;

  vm.saveChanges = function() {
    // SHOULD BE MOVED INTO ACTION -> USERSTORE
    UserStore.updatePassword({
      oldPassword: vm.oldPassword,
      newPassword: vm.newPassword,
      passwordConfirmation: vm.passwordConfirmation
    }).then(function() {
      SaturnGrowl.newGrowl('Your password has been successfully updated.', {
        type: 'normal'
      });

      vm.clearChangePassword();
    }).catch(function(err) {
      SaturnGrowl.newGrowl(_.get(err, ['data', 'error', 'friendlyMessage'], 'An error has ocurred, please review your password input.'), {
        type: 'warning'
      });
    });
  };

  vm.clearChangePassword = function() {
    vm.oldPassword = '';
    vm.newPassword = '';
    vm.passwordConfirmation = '';
  };

  vm.forgotPassword = function() {
    RoutingUtil.redirectTo('forgot-password');
  };
}

ChangePasswordController.$inject = ['UserStore', 'RoutingUtil', 'SaturnGrowl'];
module.exports = ChangePasswordController;



// WEBPACK FOOTER //
// ./src/app/settings/changePassword/ChangePasswordController.js